import { ILocation } from '../interfaces/heavyDutyMachinery/ILocation';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

// HeavyDutyMachineryApi's own host, same as HeavyDutyMachineryService — this
// endpoint is backed by Azure Maps (see LocationsController on that API),
// mirroring Authentication76's MarketplaceService.searchLocations.
const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

export const searchLocations = async (query: string, geographyOnly?: boolean): Promise<ILocation[]> => {
  if (!query.trim()) return [];

  const response = await apiService<ILocation[]>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_LOCATIONS_SEARCH,
    method: HTTP_METHODS.GET,
    params: geographyOnly ? { query, geographyOnly: 'true' } : { query },
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to search locations');
};

// Searches this app's own deduplicated location cache (HeavyDutyMachineryLocation on
// the backend) instead of Azure Maps — for the Wall's browse-page filter,
// so a suggestion never points at a place with zero matching spaces, and
// two spaces sharing the same location only ever surface as one option.
export const suggestLocations = async (query: string): Promise<ILocation[]> => {
  if (!query.trim()) return [];

  const response = await apiService<ILocation[]>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_LOCATIONS_SUGGEST,
    method: HTTP_METHODS.GET,
    params: { query },
    baseUrl: heavyDutyMachineryBaseUrl,
  });

  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to suggest locations');
};
